import { useEffect, useState } from "react";
import { getMainUsers, getUserGroups } from "../../../api";
import { getCurrentCabinet } from "../../../helpers/functions";
import { Assignees, UserGroup } from "../types";

export interface DirectoryUser {
    uuid: string;
    name?: string;
    email?: string;
}

/** Cabinet roles an approval can be assigned to (CommonLib\DTO\Role). */
export const APPROVAL_ROLES = [
    'ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_CONTENT', 'ROLE_ANALYTIC', 'ROLE_INTEGRATOR',
    'ROLE_SALES_ADMIN', 'ROLE_SALES_MANAGER', 'ROLE_SALES_CONTENT', 'ROLE_WORKFLOW_MANAGER',
];

export const emptyAssignees = (): Assignees => ({ users: [], groups: [], roles: [] });

/** Users and groups of the current cabinet, to show and pick approval assignees. */
export const useDirectory = () => {
    const [users, setUsers] = useState<DirectoryUser[]>([]);
    const [groups, setGroups] = useState<UserGroup[]>([]);

    useEffect(() => {
        const cabinet = getCurrentCabinet() || undefined;
        getMainUsers({ page: 1, maxResults: 500, cabinetUuid: cabinet?.uuid } as any).then((r: any) => setUsers(r.items || [])).catch(() => setUsers([]));
        getUserGroups().then((r: any) => setGroups(r.items || [])).catch(() => setGroups([]));
    }, []);

    const userLabel = (uuid?: string | null) => {
        if (!uuid) {
            return '—';
        }
        const user = users.find((u) => u.uuid === uuid);

        return user ? (user.name || user.email || uuid) : uuid;
    };
    const groupLabel = (uuid: string) => groups.find((g) => g.uuid === uuid)?.name || uuid;

    return { users, groups, userLabel, groupLabel };
};
